import { createReducer } from 'utils/appHelpers';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { removeFromStore } from 'utils/storeHelpers';
import { getProfile } from 'graphql/user/queries';
import { getUserFollows } from 'app/routes/Dashboard/actions/user';
import { updateProfileMutation } from 'graphql/user/mutations';
import { setAnalyticsUserId } from 'utils/analyticsHelpers';
import i18n from 'i18next';

const ON_AUTH_SATE = '@@auth/ON_AUTH_SATE';
const ON_SET_ACCOUNT = '@@auth/ON_SET_ACCOUNT';
export const ON_LOGOUT = '@@auth/ON_LOGOUT';

export const onAuthState = payload => ({ type: ON_AUTH_SATE, payload });
export const onSetAccount = payload => ({ type: ON_SET_ACCOUNT, payload });
const onLogout = () => ({ type: ON_LOGOUT });

const isAuthHandlers = {
  [ON_AUTH_SATE]: (state, action) => action.payload,
  [ON_LOGOUT]: () => 0,
};

const accountHandlers = {
  [ON_SET_ACCOUNT]: (state, action) => action.payload,
  [ON_LOGOUT]: () => null,
};

export const cleanCognitoStorage = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.includes('CognitoIdentityServiceProvider')) {
      removeFromStore(key);
    }
  });
};

export const isEmailVerified = account => {
  if (account.auth_provider === 'Google' || account.auth_provider === 'Facebook' || account.email_verified) {
    return true;
  }
  return false;
};

const getUserLoginProvider = identities => {
  try {
    if (!identities) return 'Manual';
    const items = JSON.parse(identities);
    const provider = items?.find(i => i.primary);
    return provider?.providerType || 'Manual';
  } catch (err) {
    return 'Manual';
  }
};

export const getUserProfile = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    const { data } = await API.graphql(graphqlOperation(getProfile));
    setAnalyticsUserId(user.attributes.sub);
    data.getProfile.auth_provider = getUserLoginProvider(user.attributes.identities);
    data.getProfile.email_verified = user.attributes.email_verified;
    if (data.getProfile.picture) {
      const isFbPicture = data.getProfile.picture.includes('platform-lookaside.fbsbx.com');
      if (!isFbPicture) {
        data.getProfile.picture = `${data.getProfile.picture}?v=${Math.random().toFixed(2)}`;
      }
    }
    await getUserFollows(data.getProfile.id);
    return data.getProfile;
  } catch (err) {
    throw err;
  }
};

export const checkAuthState = () => async dispatch => {
  try {
    const user = await getUserProfile();
    dispatch(onSetAccount({ ...user }));
    dispatch(onAuthState(1));
  } catch (err) {
    dispatch(onLogout());
    dispatch(onAuthState(0));
  }
};

export const onAuthStateChange = (e, history) => async dispatch => {
  try {
    const { event } = e.payload;
    if (event === 'signOut') {
      dispatch(onAuthState(0));
      dispatch(onLogout());
      history.push('/?l=1');
      removeFromStore('auth_ext');
      cleanCognitoStorage();
    } else if (event === 'signIn') {
      const user = await getUserProfile();
      API.graphql(graphqlOperation(updateProfileMutation, { profile: { locale: i18n.language } }));
      dispatch(onSetAccount({ ...user }));
      dispatch(onAuthState(1));
    }
  } catch (err) {
    dispatch(onLogout());
    dispatch(onAuthState(0));
    removeFromStore('auth_ext');
    cleanCognitoStorage();
  }
};

export const isAuthInitialState = null;
export const accountInitialState = null;

export const accountReducer = createReducer(accountInitialState, accountHandlers);
export const isAuthReducer = createReducer(isAuthInitialState, isAuthHandlers);
